import { dateUtils } from 'shared';

import type { bookingStateTypes } from '@/features/booking-state';

import type { MedicalInsuranceFormPassenger } from './types';

export function normalizePassengers(
  passengers: MedicalInsuranceFormPassenger[],
): bookingStateTypes.MedicalInsuranceProductsState[] {
  return passengers
    .filter(passenger => passenger.isSelected)
    .map(passenger => ({
      payload: {
        id: passenger.productId,
        data: {
          passengers: [
            {
              idx: passenger.idx,
              passport_issue_date: dateUtils.dateToAccountsFormat(
                passenger.passportDate,
              ),
            },
          ],
        },
      },
      price: Number(passenger.productPriceAmount),
    }));
}
